module.exports = __webpack_public_path__ + "img/trash.0d10f8f1.svg";